// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hint[data-v-3c98c9d8]{display:flex;grid-gap:4px;gap:4px;align-items:center}.hint__icon[data-v-3c98c9d8]{flex-shrink:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
